export const SET_PRICE_DATA = 'SET_PRICE_DATA';

export const UPDATE_CHART_OPTION = 'UPDATE_CHART_OPTION';

export const TOGGLE_ANNOTATION = 'TOGGLE_ANNOTATION';

export const CHANGE_ASSET = 'CHANGE_ASSET';